import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {PercursoService} from "../../../services/percurso/percurso.service";
import {ComboPercurso} from "../../../core/combo-percurso";

@Component({
    selector: 'combo-percurso',
    templateUrl: './combo-percurso.component.html',
    styleUrls: ['./combo-percurso.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboPercursoComponent implements OnInit {

    @ViewChild('comboPercurso', {static: false}) comboPercurso;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private percursoService: PercursoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.percursoService.getAllCombo().subscribe((percursos: ComboPercurso[]) => {
                this.dados = percursos;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
